import React from 'react';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';

export const MarketplacePurchaseRetunPage = (props) => {
  const history = useHistory();
  const searchObject = queryString.parse(history.location.search);

  console.log('searchObject', searchObject);
  return <article className='basic-page'>MarketplacePurchaseRetunPage</article>;
};
